module.exports = __webpack_public_path__ + "images/drawings/moon/waxing-gibbous.e73433d487f3c7167631a42b865173c6.png";